import React from 'react';
import Navbar from '../components/Navbar';
import BifrostHero from '../components/BifrostHero';
import BifrostFeatures from '../components/BifrostFeatures';
import BifrostSocialGrid from '../components/BifrostSocialGrid';

const BifrostPage = () => {
  return (
    <div className="min-h-screen bg-white font-sans text-gray-900">
      <Navbar />
      <main>
        <BifrostHero />
        
        {/* Value Prop Highlight - Matching Memories/Avatars Layout */}
        <section className="py-24 bg-white border-y border-gray-100">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
            <h2 style={{
      color: 'rgb(17, 24, 39)'
    }} className="text-3xl md:text-4xl font-extrabold text-gray-900 mb-6">Publish via BookMeIn.Events -<span style={{
      color: 'rgb(79, 70, 229)'
    }} className="text-indigo-600">Share Everywhere.</span>
            </h2>
            <p className="text-gray-600 text-xl max-w-3xl mx-auto mb-10 leading-relaxed">
              No more logins, no more uploads. Just send your content to your private Bifrost bridge email and our AI-powered transformation engine handles the 13-network distribution.
            </p>
            <div className="flex justify-center">
              <div className="bg-indigo-50 px-12 py-8 rounded-2xl border border-indigo-100 max-w-lg">
                <p className="text-indigo-600 font-black text-5xl mb-2">10x</p>
                <p className="text-indigo-900 font-bold uppercase tracking-wider text-sm">FASTER PUBLISHING SPEED</p>
              </div>
            </div>
          </div>
        </section>

        <BifrostFeatures />
        <BifrostSocialGrid />
        
      </main>
    </div>
  );
};

export default BifrostPage;